import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { FiStar, FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';
import t1 from '../../assets/t1.jpg';
import t2 from '../../assets/t2.jpg';
import t3 from '../../assets/t3.jpg';
import styles from './Testimonials.module.css';

const avatars = [t1, t2, t3];

export default function Testimonials() {
  const { t } = useTranslation();
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.15 });
  const [idx, setIdx] = useState(0);

  const reviews = [
    { name: t('testimonials.reviews.r1.name'), role: t('testimonials.reviews.r1.role'), img: avatars[0], text: t('testimonials.reviews.r1.text') },
    { name: t('testimonials.reviews.r2.name'), role: t('testimonials.reviews.r2.role'), img: avatars[1], text: t('testimonials.reviews.r2.text') },
    { name: t('testimonials.reviews.r3.name'), role: t('testimonials.reviews.r3.role'), img: avatars[2], text: t('testimonials.reviews.r3.text') },
  ];

  const prev = () => setIdx(i => (i - 1 + reviews.length) % reviews.length);
  const next = () => setIdx(i => (i + 1) % reviews.length);

  return (
    <section className={styles.section} ref={ref}>
      <div className={styles.container}>
        <motion.div className={styles.header}
          initial={{ opacity: 0, y: 24 }} animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}>
          <span className={styles.label}><span className={styles.labelLine}/> {t('testimonials.label')}</span>
          <h2 className={styles.heading}>{t('testimonials.heading1')}<br /><span className={styles.accent}>{t('testimonials.heading2')}</span></h2>
        </motion.div>

        <motion.div className={styles.carousel}
          initial={{ opacity: 0, y: 30 }} animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.7, delay: 0.2 }}>
          <AnimatePresence mode="wait">
            <motion.div key={idx} className={styles.card}
              initial={{ opacity: 0, x: 30 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: -30 }}
              transition={{ duration: 0.3 }}>
              <div className={styles.stars}>
                {[...Array(5)].map((_, i) => <FiStar key={i} className={styles.star} fill="currentColor"/>)}
              </div>
              <p className={styles.quote}>"{reviews[idx].text}"</p>
              <div className={styles.author}>
                <img src={reviews[idx].img} alt={reviews[idx].name} className={styles.avatar} />
                <div>
                  <span className={styles.authorName}>{reviews[idx].name}</span>
                  <span className={styles.authorRole}>{reviews[idx].role}</span>
                </div>
              </div>
            </motion.div>
          </AnimatePresence>

          <div className={styles.controls}>
            <button className={styles.ctrl} onClick={prev}><FiChevronLeft size={20}/></button>
            <div className={styles.dots}>
              {reviews.map((_, i) => (
                <button key={i} className={`${styles.dot} ${i === idx ? styles.dotActive : ''}`} onClick={() => setIdx(i)} />
              ))}
            </div>
            <button className={styles.ctrl} onClick={next}><FiChevronRight size={20}/></button>
          </div>
        </motion.div>

        <div className={styles.allCards}>
          {reviews.map((r, i) => (
            <motion.div key={r.name} className={styles.miniCard}
              initial={{ opacity: 0, y: 20 }} animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.5, delay: 0.3 + i * 0.1 }}>
              <div className={styles.miniStars}>
                {[...Array(5)].map((_, j) => <FiStar key={j} className={styles.star} fill="currentColor" size={13}/>)}
              </div>
              <p className={styles.miniQuote}>"{r.text}"</p>
              <div className={styles.miniAuthor}>
                <img src={r.img} alt={r.name} className={styles.miniAvatar}/>
                <div>
                  <span className={styles.authorName}>{r.name}</span>
                  <span className={styles.authorRole}>{r.role}</span>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
